module.exports = __webpack_public_path__ + "f9cb1e1c9a3cbd1ac54e33c8fd08adec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/community-workouts-light.png
// module id = 1868
// module chunks = 1